import { CMBox, CMBoxcontainer, CMBoxError, CMOffer } from "./transaction-failure.styles";
import Button, { BUTTON_TYPE_CLASSES } from "../../button/button.component";

const TransactionFailure = ({ information }) => {
  return (
    <>
      <CMBoxcontainer>
        <CMBox>
        <h3>{information} <br/> Please contact the website administrator.</h3>
        </CMBox>
      </CMBoxcontainer>
    </>
  );
};
export default TransactionFailure;
